import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import fetchApi from '../../services/fetchApi'
import CircleChart from './CircleChart'
import ReviewsBox from './ReviewsBox'
import LoadingSpinner from '../sitewide/Spinner'
import ScheduleBox from '../sitewide/ScheduleBox'
import AllLocationsCheckbox from '../sitewide/Filter/AllLocationsCheckbox'
import css from './styles.css'


class Reviews extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoaded: false,
      allTime: {
        total: 0,
        positive: 0,
        negative: 0,
      },
      last30Days: {
        total: 0,
        positive: 0,
        negative: 0,
      },
      totalPositiveReviews: 0,
      totalPositiveReviewsLast30Days: 0,
      byDoctor: [],
      byLocation: [],
      appointments: [],
      searchAllLocations: false,
    }
  }

  componentDidMount() {
    this.fetchReviews()
  }

  componentDidUpdate(prevProps) {
    const { activeLocation, hasDSO } = this.props
    if (
      hasDSO &&
      activeLocation &&
      prevProps.activeLocation &&
      prevProps.activeLocation.id !== activeLocation.id
    ) {
      this.fetchReviews()
    }
  }

  setUrlForFetch = () => {
    const { activeLocation, hasDSO } = this.props
    const { searchAllLocations } = this.state

    return hasDSO && activeLocation
      ? `/reviews?location_id=${activeLocation.id}&all_locations=${searchAllLocations}`
      : '/reviews'
  }

  async fetchReviews() {
    const {
      all_time: allTime,
      last_30_days: last30Days,
      by_doctor: byDoctor,
      by_location: byLocation,
      appointments,
    } = await fetchApi(this.setUrlForFetch(), 'GET')
    this.setState({
      isLoaded: true,
      allTime,
      last30Days,
      byDoctor,
      byLocation,
      appointments,
    })
  }

  handleAllLocationsCheckbox = (e) => {
    e.stopPropagation()
    this.setState({ searchAllLocations: e.target.checked }, this.fetchReviews)
  }

  render() {
    const { hasDSO, userLocations, pmsType } = this.props
    const {
      allTime: { total, negative, positive },
      appointments,
      byDoctor,
      byLocation,
      isLoaded,
      last30Days,
      searchAllLocations,
    } = this.state
    const data = [{ value: negative }, { value: !total ? 1 : positive }]
    const allTimePositivePercent = ((positive / (total || 1)) * 100).toFixed()
    const positiveString = !total
      ? 'n/a'
      : `${allTimePositivePercent}% Positive`

    const showAllLocationsCheckbox = hasDSO && userLocations && userLocations.length > 1

    return (
      <div className={css.container}>
        {!isLoaded ? (
          <div className={css.spinner}>
            <LoadingSpinner isAbs />
          </div>
        ) : (
          <div className="Reviews">
            <div className={css.reviewsHeadsUp}>
              <div className={css.circle}>
                <CircleChart
                  data={data}
                  primaryColor="#c1595c"
                  secondaryColor="#89c063"
                  height={120}
                  width={120}
                  innerRadius={0}
                  outerRadius={60}
                >
                  <div />
                  <span className={css.label}>
                    <strong>{positiveString}</strong>
                  </span>
                </CircleChart>
              </div>
              <ReviewsBox
                totalCount={total}
                last30Days={last30Days}
                byDoctor={byDoctor}
                byLocation={byLocation}
              />
              <div className={css.totalStats}>
                <div className={css.positive}>
                  <div className={css.count}>{positive}</div>
                  <span>Positive</span>
                </div>
                <div className={css.negative}>
                  <div className={css.count}>{negative}</div>
                  <span>Negative</span>
                </div>
              </div>
            </div>
            {showAllLocationsCheckbox && (
              <div className={css.allLocationCheckbox}>
                <AllLocationsCheckbox
                  checked={searchAllLocations}
                  handleCheck={this.handleAllLocationsCheckbox}
                />
              </div>
            )}
            <div className={css.ScheduleList}>
              <ScheduleBox
                forReviews
                appointments={appointments}
                pmsType={pmsType}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}

Reviews.propTypes = {
  activeLocation: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    additional_recipients: PropTypes.arrayOf(PropTypes.object),
    city: PropTypes.string,
    country_code: PropTypes.string,
    created_at: PropTypes.string,
    doctor_id: PropTypes.string,
    earliest_same_day_reminder_hour: PropTypes.number,
    facebook_url: PropTypes.string,
    forwarding_email: PropTypes.string,
    google_url: PropTypes.string,
    id: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    name: PropTypes.string,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.object),
    practice_id: PropTypes.number,
    state: PropTypes.string,
    street_address: PropTypes.string,
    timezone: PropTypes.string,
    updated_at: PropTypes.string,
    website: PropTypes.string,
    yelp_url: PropTypes.string,
    zip: PropTypes.string,
  }),
  hasDSO: PropTypes.bool.isRequired,
  userLocations: PropTypes.arrayOf(PropTypes.object),
}

const mapStateToProps = ({
  account: {
    auth: { hasDSO, pmsType },
    user: { activeLocation, locations: userLocations },
  },
}) => ({
  activeLocation,
  hasDSO,
  pmsType,
  userLocations,
})

export default connect(mapStateToProps, null)(Reviews)



// WEBPACK FOOTER //
// ./src/components/Dashboard/Reviews.js